function setDetailsHeight(selector: HTMLDetailsElement) {
  const setHeight = (detail: HTMLDetailsElement, open = false) => {
    detail.open = open;
    const rect = detail.getBoundingClientRect();
    detail.style.setProperty(
      open ? `--expanded` : `--collapsed`,
      `${rect.height}px`
    );
  };

  const detail = selector;
  detail.removeAttribute('style');
  setHeight(detail);
  setHeight(detail, true);
  detail.open = false;
}

export default setDetailsHeight;
